import {
  getSchoolYearLabel,
  getSeasonYears,
} from "@/lib/dormant-season/helpers";
import { isHiringSeasonDormant } from "@/lib/dormant-season/resolve";

type QuizIntroCopy = {
  title: string;
  matchingMessage: string;
  isSeasonNotice: boolean;
};

const LIVE_INTRO_TITLE = "School Preference Quiz";

const LIVE_MATCHING_MESSAGE =
  "We'll use your answers to match you with schools that are a great fit for you! ✨";

const LIVE_PROMPT_BLURB =
  "Our 5 min quiz will help get you the best matches and supercharge your job search! 🚀";

const LIVE_RESULTS_READY_DESCRIPTION =
  "Your first personalized school recommendations are ready. Click below to see your top matches!";

const LIVE_RESULTS_WEEKLY_DESCRIPTION =
  "Each week we'll recommend a set of schools that we think could be a great fit. Check back on Monday to see your first recommendations.";

const weeklyRecommendationsRestart = (next: number) =>
  `Weekly recommendations start when matching reopens in early January ${next}.`;

export function getQuizIntroCopy(now: Date): QuizIntroCopy {
  if (!isHiringSeasonDormant("quiz")) {
    return {
      title: LIVE_INTRO_TITLE,
      matchingMessage: LIVE_MATCHING_MESSAGE,
      isSeasonNotice: false,
    };
  }

  const { next } = getSeasonYears(now);

  return {
    title: "Take the match quiz for next season",
    matchingMessage: `You take the quiz once. ${weeklyRecommendationsRestart(next)}`,
    isSeasonNotice: true,
  };
}

export function getQuizPromptBlurb(now: Date): string {
  if (!isHiringSeasonDormant("quiz")) {
    return LIVE_PROMPT_BLURB;
  }

  const { next } = getSeasonYears(now);

  return `Take the 5 min quiz now and your answers will be ready when matching reopens in early January ${next}! 🚀`;
}

export function getQuizResultsDescription({
  now,
  canGenerateRecommendations,
}: {
  now: Date;
  canGenerateRecommendations: boolean;
}): string {
  if (isHiringSeasonDormant("quiz")) {
    const { next } = getSeasonYears(now);

    return `Your answers are set for the ${getSchoolYearLabel(next)} school year. ${weeklyRecommendationsRestart(next)}`;
  }

  return canGenerateRecommendations
    ? LIVE_RESULTS_READY_DESCRIPTION
    : LIVE_RESULTS_WEEKLY_DESCRIPTION;
}
